// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const tooltipClasses = {
  arrow: "qui-tooltip__arrow",
  arrowTip: "qui-tooltip__arrow-tip",
  content: "qui-tooltip__content",
  positioner: "qui-tooltip__positioner",
  root: "qui-tooltip__root",
} as const
